export default {
  namespaced: true,
  digital_signature: {
    title: "Assinatura digital",
    file_video: "Arquivo de vídeo",
    file_signature: "Assinatura de arquivo",
  },
};
